import React from 'react'

/**
 * StepBubble - component that represent each step of the designer
 *
 * @component
 *
 * @param {Object} params - The properties of the StepBubble component
 * @param {'current' | 'previous' | 'next'} [params.type = 'current'] - State of the button depending on stage
 * of completeness of the designer
 * @param {string} params.className - Additional custom tw classes
 * @param {number} params.step - Bubble's label that is order number of the step that it describes
 * @param {boolean} [params.keepEnabled = false] - A flag that makes future steps clickable in case user
 * already completed intermediary steps and came back
 * @param {function()} params.onClick - Function that is called when the button is triggered
 * @returns {ReactElement} StepBubble Component
 */
const StepBubble = ({ type = 'current', className = '', step, onClick }) => {
  const disabled = type !== 'previous'

  return (
    <button
      className={`step-bubble ${type} ${className ? className : ''}`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {step}
    </button>
  )
}

export default StepBubble
